import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  return <div className="sticky top-0 z-50 bg-brand-teal text-white text-[11px] font-medium py-1 px-3 text-center shadow-md" data-id="element-270">
      <p data-id="element-271">
        ⏰ Precio de lanzamiento — cierra en: {hours}:{minutes}:{seconds}
      </p>
    </div>;
}